// After a pin is added, edited, renamed or removed: inside the pin editor's
// dialog (assistants/_pins_dialog) reload just the editor's frame, so the
// dialog stays open on the new list; anywhere else reload the page, as these
// editors always did.
//
// The reloaded editor reopens the folder that was open (pinned_list reads it
// off the frame), or `open` - a folder id, or "root" for the top list.
export function refreshPins(element, { open } = {}) {
    const frame = element?.closest("turbo-frame#home_pins")
    if (!frame?.reload) return window.location.reload()

    const folder = open ?? frame.querySelector(".home-pins-folder:not([hidden])")?.dataset.folderId
    if (folder && folder !== "root") frame.dataset.openFolder = folder
    else delete frame.dataset.openFolder
    frame.reload()
}
